import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'UI';

import {
  MainContainer,
} from './style';

interface GreenhouseExtraProps {
  onAddClick(): void
}

const GreenhouseExtra = ({
  onAddClick,
}: GreenhouseExtraProps): JSX.Element => (
  <MainContainer>
    <Button
      icon={<PlusOutlined size={14} />}
      onClick={onAddClick}
    >
      Cadastrar nova estufa
    </Button>
  </MainContainer>
);

export default GreenhouseExtra;
